export default __webpack_public_path__ + "static/media/FOTOS_DISCO_07.73480c1a.jpg";